import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _calculateMultiSlotAvailabilityRequest = {};
var _calculateMultiSlotAvailabilityResponse = {};
var _getAvailabilityTimeSlotRequest = {};
var _getAvailabilityTimeSlotResponse = {};
var _getScheduleAvailabilityRequest = {};
var _getScheduleAvailabilityResponse = {};
var _getSlotAvailabilityRequest = {};
var _getSlotAvailabilityResponse = {};
var _queryAvailabilityRequest = {};
var _queryAvailabilityResponse = {};
function resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/availability-calendar',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v2/availability/schedule',
                destPath: '/v2/availability/schedule',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
            {
                srcPath: '/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
            {
                srcPath: '/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
            {
                srcPath: '/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/bookings/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/bookings/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar',
                destPath: '',
            },
            {
                srcPath: '/_api/availability-calendar/v2/availability/schedule',
                destPath: '/v2/availability/schedule',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the availability for sessions
 * that match the provided query criteria (filtering and sorting).
 *
 *
 * The Calendar Availability APIs calculate the availability of sessions for
 * appointments and classes, but not
 * for courses.
 *
 * The entire list of slots is returned in case you want to display both
 * available and non-available slots in the calendar for your customers.
 * Using the `bookable` property, you can limit the display to available
 * slots only.
 *
 * When querying, you must enter a service ID, a start date and an end date. This avoids very large
 * results that can impact performance.
 *
 * #### Calculating availability
 *
 * The availability is determined
 * by checking:
 * - **The sessions' open slots**. A slot is considered open if the session's capacity is greater than number of participants.
 * - **Booking policies**. Policies that affect whether a slot is considered available include `tooEarlyToBook`, `tooLateToBook`, and `bookOnlineDisabled`.
 *
 * Locked sessions do not impact session availability and `bookable` can
 * be `true` even if `locked` is `true`. For example, if a session has a waitlist and a
 * place frees up, the slot is offered to the customers on the waitlist, one by one. The
 * session remains locked because there is still a wait-list, but for a period of time
 * there is availability, until a customer on the waitlist takes the slot. Locking
 * prevents customers who are not yet on the wait-list from grabbing the slot.
 *
 * #### Handling Daylight Savings Time (DST) for local time zones
 *
 * Because of DST, there are cases where certain times either do not exist
 * or exist twice for a local time zone.
 * For example, the time `00:05` on September 5th 2021 might not exist in Santiago, Chile,
 * because at `00:00` the clock moved
 * 1 hour forward to `01:00`.
 *
 * In this case, the Availability APIs take this
 * into account and mediate the time gaps automatically. The non-existent local time is
 * automatically moved forward 1 hour to match local DST. Local times that exist do not change.
 * So if the `Query Availability` endpoint is called with a `startDate` of `2021-09-05T00:00:01.000`
 * and an `endDate` of `2021-09-06T00:00:02.000`, `2021-09-05T01:00:01.000` is used in the query
 * instead. The start time shifts one hour forward and the end time remains the same.
 */
export function queryAvailability(payload) {
    var _a = serializer(_queryAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAvailabilityResponse, {}).fromJSON;
    function __queryAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.QueryAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/availability/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAvailability.fromReq = fromReq;
    __queryAvailability.__isAmbassador = true;
    return __queryAvailability;
}
/**
 * Returns the availability for a given slot.
 *
 * A slot for an appointment does not have a `sessionId. Only a slot for a class has a `sessionId`.
 *
 * Availability for an appointment is calculated as follows:
 * - Checking for available slots in the calendar, and calculating the open spots
 * - Checking for existing bookings with overlapping time, service & resource, where the booked session has transparency set to  `"BUSY"`  When the booking is in the process of being checked out, it may not have a sessionId yet. In this case it is considered as `"BUSY"`.
 * - Checking for booking policy violations in the services-catalog.
 * The following fields are required to get the availability for an appointment:
 * - `startDate`
 * - `endDate`
 * - `serviceId`
 * - `resourceId`
 * - `scheduleId`
 * Availability for classes is calculated as follows:
 * - Checking for total spots by the session's capacity
 * - Checking for open spots by subtracting the current number of participants from the total spots
 * - Checking for booking policy violations in the services-catalog
 * - Checking for a waitlist and its occupancy in the waiting-list
 * - Checking for locked in the locks
 * For a class, the following fields are required:
 * - `sessionId`
 */
export function getSlotAvailability(payload) {
    var _a = serializer(_getSlotAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSlotAvailabilityResponse, {}).fromJSON;
    function __getSlotAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetSlotAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v2/availability/slot',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSlotAvailability.fromReq = fromReq;
    __getSlotAvailability.__isAmbassador = true;
    return __getSlotAvailability;
}
/**
 * Returns availability for a given schedule ID
 * The availability for a course is calculated by:
 * - Checking for total spots by the schedule's capacity
 * - Checking for open spots by subtracting the current number of participants from the total spots
 * current number of participants is calculated by summing the number of participants of all bookings booked to the schedule
 * @deprecated
 */
export function getScheduleAvailability(payload) {
    var _a = serializer(_getScheduleAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleAvailabilityResponse, {}).fromJSON;
    function __getScheduleAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetScheduleAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v2/availability/schedule/{scheduleId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduleAvailability.fromReq = fromReq;
    __getScheduleAvailability.__isAmbassador = true;
    return __getScheduleAvailability;
}
export function calculateMultiSlotAvailability(payload) {
    var _a = serializer(_calculateMultiSlotAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateMultiSlotAvailabilityResponse, {}).fromJSON;
    function __calculateMultiSlotAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.CalculateMultiSlotAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/availability/multislot',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateMultiSlotAvailability.fromReq = fromReq;
    __calculateMultiSlotAvailability.__isAmbassador = true;
    return __calculateMultiSlotAvailability;
}
/**
 * a decision based proxy between GetSlotAvailability and  service-availability's GetAvailabilityTimeSlot
 * this is a temporary solution based on FromV2 flag, and will be removed once all the clients are migrated to v2
 * the request will be proxied to GetSlotAvailability if from_v2 is false, and to GetAvailabilityTimeSlot if from_v2 is true
 * it supports only appointment services (NOT classes, and NOT courses)
 * in case from_v2 is not provided, the request will be proxied based on `ShouldCallAvailabilityService` FT and ResourceManagement check [exists not staff resource]
 * in case from_v2 is false and ResourceManagement check is true, an FAILED_PRECONDITION error will be thrown
 */
export function getAvailabilityTimeSlot(payload) {
    var _a = serializer(_getAvailabilityTimeSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAvailabilityTimeSlotResponse, {}).fromJSON;
    function __getAvailabilityTimeSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetAvailabilityTimeSlot',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/time-slots/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAvailabilityTimeSlot.fromReq = fromReq;
    __getAvailabilityTimeSlot.__isAmbassador = true;
    return __getAvailabilityTimeSlot;
}
//# sourceMappingURL=http.impl.js.map